import { IconServers } from '@smartbear/swagger-portal-component-library'

import { CommonSearchResultTile, HighlightedTitle } from '../CommonSearchResultTile'
import { SearchResult } from '~/portal/types/search'

interface ServerSearchResultTileProps {
  result: SearchResult
  onClose: () => void
  tileKey: string
}

export const ServerSearchResultTile = ({ result, onClose, tileKey }: ServerSearchResultTileProps) => {
  const url = `/${result.product.slug}/${result.href}#/default/server-${result.serverId}`

  const icon = (
    <span className="mt-px">
      <IconServers />
    </span>
  )

  const titleContent = (
    <div>
      Servers
      {' / '}
      <HighlightedTitle titleSnippet={result.titleSnippet} removeLeadingSlash={!result.summary} />
    </div>
  )

  return (
    <CommonSearchResultTile
      result={result}
      onClose={onClose}
      tileKey={tileKey}
      icon={icon}
      url={url}
      titleContent={titleContent}
    />
  )
}